import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-pillar-mall",
  "use": "icon-soc-pillar-mall-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-pillar-mall\">\r\n  <!-- ⑤ 生态商城·招商：展台线框（非购物车） -->\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <path d=\"M192 320l320-128 320 128\" />\r\n    <path d=\"M256 320v320M768 320v320\" />\r\n    <path d=\"M192 640h640\" />\r\n    <path d=\"M192 736h640\" />\r\n    <circle cx=\"448\" cy=\"480\" r=\"36\" />\r\n    <circle cx=\"576\" cy=\"480\" r=\"36\" />\r\n    <path d=\"M484 480h56\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-pillar-mall.svg
// module id = aHfQ
// module chunks = 488